export const EDIT_POSITION = "EDIT_POSITION"
export const EDIT_POSITION_SUCCESS = "EDIT_POSITION_SUCCESS"
export const EDIT_POSITION_CLEAN = "EDIT_USER_CLEAN"
export const EDIT_POSITION_ERROR = "EDIT_POSITION_ERROR"
